// src/dataTypes/broadcastingManagment/types_thirdPartyStreamingSystem.ts

export interface ThirdPartyStreamingService {
  id           : number;
  active       : boolean;
  name         : string;
  description  : string;
  ingestionUrl : string;
  watchUrl     : string;
  rank         : number;
}

export const initializedThirdPartyStreamingService = (): ThirdPartyStreamingService => ({
  id           : 0,
  active       : false,
  name         : "",
  description  : "",
  ingestionUrl : "",
  watchUrl     : "",
  rank         : 0
});

export interface ThirdPartyStreamingChannel {
  id                           : number;
  active                       : boolean;
  name                         : string;
  description                  : string;
  ingestionKey                 : string;
  streamUrl                    : string;
  backupUrl                    : string;
  broadcastingChannelId        : number;
  thirdPartyStreamingServiceId : number;
 }

export const initializedThirdPartyStreamingChannel = (): ThirdPartyStreamingChannel => ({
  id                           : 0,
  active                       : false,
  name                         : "",
  description                  : "",
  ingestionKey                 : "",
  streamUrl                    : "",
  backupUrl                    : "",
  broadcastingChannelId        : 0,
  thirdPartyStreamingServiceId : -1,
});

